import Backdrop from "@mui/material/Backdrop";
import React from "react";

import styles from "./InferencingBackdrop.module.scss";

interface InferencingBackdropProps {
  isInferencing: boolean;
  heading: string;
  subHeading?: string;
}

const InferencingBackdrop: React.FC<InferencingBackdropProps> = ({
  isInferencing,
  heading,
  subHeading,
}) => {
  return (
    <Backdrop open={isInferencing} sx={{ zIndex: "10" }}>
      <div className={styles.inferencingCon}>
        <div>
          <img className={styles.gif} src="/loading.gif" alt="loading" />
        </div>
        <div className={styles.textCon}>
          <div className={styles.heading}>{heading}</div>
          {subHeading && <div className={styles.subHeading}>{subHeading}</div>}
        </div>
      </div>
    </Backdrop>
  );
};

export default InferencingBackdrop;
